// extracted by mini-css-extract-plugin
export default {"application-status-pill":"style_application-status-pill__LJqp3","applicationStatusPill":"style_application-status-pill__LJqp3","tooltip":"style_tooltip__+rLV2"};